import { render } from "./DestinationTypes.vue?vue&type=template&id=2f43c221&scoped=true&lang=html"
import script from "./DestinationTypes.vue?vue&type=script&lang=js"
export * from "./DestinationTypes.vue?vue&type=script&lang=js"

import "./DestinationTypes.vue?vue&type=style&index=0&id=2f43c221&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f43c221"]])

export default __exports__